<template>
  <el-main>
    <div class="top-wrap">
      <Bread></Bread>
    </div>
    <div class="main">
      <div class="content" v-loading="loading">
        <el-row type="flex" justify="end" style="margin-bottom: 16px">
          <el-button type="primary" plain @click="onSelectAllBtnClick"
            >一键全选</el-button
          >
        </el-row>
        <div class="plate">
          <draggable
            v-model="oneLevelMenu"
            v-bind="dragOptions"
            @start="drag = true"
            @end="drag = false"
          >
            <transition-group
              type="transition"
              :name="!drag ? 'flip-list' : null"
            >
              <div
                class="item w-20vw cursor-pointer"
                :class="{
                  'two-line': menu.menuName === '数字化驾驶舱系统',
                  active: menu.enable === 2,
                }"
                v-for="menu of oneLevelMenu"
                :key="menu.menuId"
                @click="menu.enable = menu.enable === 2 ? 3 : 2"
              >
                <img alt="" class="img" :src="menuIconMap[menu.menuName]" />
                <div class="info">
                  <h3 class="tit">{{ menu.menuName }}</h3>
                </div>
              </div>
            </transition-group>
          </draggable>
          <div class="bottom-btn">
            <el-button type="primary" @click="onSaveBtnClick()">
              保存
            </el-button>
            <el-button type="primary" @click="$router.go(-1)" plain
              >取消
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </el-main>
</template>

<script>
import draggable from "vuedraggable";

export default {
  name: "MenuSetting",
  components: {
    draggable,
  },
  data() {
    return {
      loading: false,
      drag: false,
      oneLevelMenu: [],
      menuIconMap: {
        基础信息管理: require("@/assets/entrance/menu_icon01.png"),
        生产经营管理: require("@/assets/entrance/menu_icon02.png"),
        社会化服务管理: require("@/assets/entrance/menu_icon03.png"),
        生产托管服务管理: require("@/assets/entrance/menu_icon04.png"),
        智联设备管理: require("@/assets/entrance/menu_icon05.png"),
        农机作业管理: require("@/assets/entrance/menu_icon06.png"),
        订单农业生产管理: require("@/assets/entrance/menu_icon07.png"),
        智慧农业管理: require("@/assets/entrance/menu_icon08.png"),
        金融贷款服务: require("@/assets/entrance/menu_icon09.png"),
        农业保险服务: require("@/assets/entrance/menu_icon10.png"),
        生产资料服务及管理: require("@/assets/entrance/menu_icon11.png"),
        农业补贴管理: require("@/assets/entrance/menu_icon12.png"),
        应急调度管理: require("@/assets/entrance/menu_icon13.png"),
        财务管理: require("@/assets/entrance/menu_icon14.png"),
        数字化驾驶舱系统: require("@/assets/entrance/menu_icon15.png"),
      },
    };
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    },
  },
  created() {
    this.selectOneLevelMenu();
  },
  methods: {
    /**
     * @description
     * @Author quwandong
     * @Date 2023-10-17 21:05:38
     */
    onSelectAllBtnClick() {
      this.oneLevelMenu = this.oneLevelMenu.map((item) => ({
        ...item,
        enable: 2,
      }));
    },
    /**
     * @description: 获取一级菜单（入口各子系统）
     * @Author: juanjuanhui
     * @Date: 2023-02-25 17:50:10
     */
    async selectOneLevelMenu() {
      try {
        this.loading = true;
        let { data } = await this.$http.common.selectOneLevelMenu({
          masterId: this.$route.query.masterId,
          systemType: 3,
        });

        this.oneLevelMenu = data
          ? data
              .slice(0, 15)
              .sort((a, b) => (a.sort > b.sort ? 1 : -1))
              .map((item) => ({
                ...item,
                enable: item.enable === null ? 3 : item.enable,
              }))
          : [];
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },
    /**
     * @description
     * @Author quwandong
     * @Date 2023-10-17 19:38:45
     */
    async onSaveBtnClick() {
      try {
        const params = this.oneLevelMenu.map((item, index) => ({
          menuId: item.menuId,
          enable: item.enable,
          sort: index,
        }));
        this.loading = true;

        await this.$http.common.updateModule({
          masterId: this.$route.query.masterId,
          moduleList: params,
        });
        this.$message.success("保存成功");
        setTimeout(() => {
          this.$router.go(-1);
        }, 300);
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  height: 100%;
  background-size: cover;

  .cursor-pointer {
    cursor: pointer;
  }

  .plate {
    width: 80vw;
    margin: 0 auto;

    ::v-deep > div > span {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      grid-template-rows: repeat(4, 1fr);
      grid-column-gap: 0;
      grid-row-gap: 0;
    }

    .item {
      display: flex;
      align-items: center;
      padding: 1vw 2vw;
      margin: 0 1.095vw 1vw 0;
      background: #ffffff;
      border-radius: 4px;
      box-sizing: border-box;
      cursor: pointer;
      height: 12.5vh;
      border: 1px solid #e3e5e5;

      &.w-20vw {
        width: 18.9vw;
      }

      .img {
        width: 4.8vw;
      }

      .info {
        margin-left: 0.5vw;

        .tit {
          padding-bottom: 0.5vw;
          font-size: 1vw;
          color: #333333;
        }

        .btn {
          padding: 7px 1vw;
          color: #018388;
          font-size: 0.8vw;
          border: 1px solid #018388;
          border-radius: 20px;
        }
      }

      &.two-line {
        grid-area: 3 / 4 / 5 / 5;
        padding: 3.6vw 2vw;
        flex-direction: column;
        justify-content: center;
        align-content: center;
        text-align: center;
        height: 27vh;

        .tit {
          font-size: 1vw;
          color: #333333;
          margin-bottom: 20px;
        }
      }

      &.active {
        background: #eafbfc;
        border: 1px solid #018489;
        position: relative;

        &::after {
          content: "";
          display: inline-block;
          width: 30px;
          height: 30px;
          position: absolute;
          bottom: 0;
          right: 0;
          background: url("~assets/entrance/icon_xuanz.png");
          background-size: 100% 100%;
        }
      }
    }

    .bottom-btn {
      display: flex;
      justify-content: center;
      margin-top: 32px;

      .el-button {
        width: 160px;
        border-radius: 27px;
      }
    }
  }
}
</style>
